import { X } from 'lucide-react';
import ImageDisplay from './ImageDisplay';

/** Individual image in the grid editor with delete button */
export default function ImageGridItem({ image, index, onDelete, onDragStart, onDragOver, onDrop, isDragging, onClick }) {
  return (
    <div
      draggable
      onDragStart={(e) => onDragStart?.(e, index)}
      onDragOver={(e) => onDragOver?.(e, index)}
      onDrop={(e) => onDrop?.(e, index)}
      onClick={() => onClick?.(index)}
      className={`relative aspect-[3/4] rounded-xl bg-secondary cursor-move transition-opacity border border-purple-500 ${
        isDragging ? 'opacity-50' : 'opacity-100'
      }`}
    >
      <ImageDisplay 
        imageData={image} 
        imageStrategy="cover"
        className="h-full w-full rounded-xl" 
      />
      
      {/* Delete button */}
      <button
        onClick={(e) => { e.stopPropagation(); onDelete?.(index); }}
        className="absolute -right-1 -top-1 flex h-9 w-9 items-center justify-center rounded-full bg-red-500/80 text-white hover:bg-red-600/90 transition"
      >
        <X className="h-4.5 w-4.5" />
      </button>
    </div>
  );
}
